import Types from '../types';

export default props => ({
  type: Types.CHANGE_HEADER_TITLE_PROPS,
  payload: props,
});
